var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_1426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.978 7.03824C19.978 3.15594 16.822 0 12.9648 0C9.1075 0 5.92651 3.15594 5.92651 7.03824C5.92651 10.1942 8.00542 12.8742 10.8858 13.7509L0.140625 30.808H25.7638L15.0186 13.7509C17.899 12.8742 19.978 10.1942 19.978 7.03824ZM8.43122 7.03824C8.43122 4.53353 10.46 2.50471 12.9648 2.50471C15.4695 2.50471 17.4983 4.53353 17.4983 7.03824C17.4983 9.54296 15.4695 11.5718 12.9648 11.5718C10.46 11.5718 8.43122 9.51791 8.43122 7.03824ZM4.67416 28.3033L12.9397 15.1535L21.2053 28.3033H4.67416Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_1426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6232,
    height: 30.808,
    fill: "white",
    transform: "translate(0.140625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpower);
export default __webpack_public_path__ + "static/media/empower.06441c3a4400fcc806a7ace75865f605.svg";
export { ForwardRef as ReactComponent };